// Loaded by layouts/_flash, so it is only requested on a page that actually has
// a flash to show. Kept out of the per-page packs because the flash partial is
// shared by the public and admin layouts and can render on any route.
import { initFlashAutoDismiss } from "@/utils/helpers/flashAutoDismiss";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initFlashAutoDismiss());
} else {
  initFlashAutoDismiss();
}
